import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import StudentDashboard from '../pages/StudentDashboard/StudentDashboard.jsx';
import Dashboard from '../pages/StudentDashboard/Dashboard.js';
import Applications from '../pages/StudentDashboard/Applications.js';
import EditProfile from '../components/EditProfile';
import ChangePassword from "../components/ChangePassword";
import Layout from "../layout/index.js";
import ApplyForScholarship from "../pages/StudentDashboard/ApplyForScholarship.js";
import MyDocuments from "../pages/StudentDashboard/MyDocuments.js";
import StudentProfile from "../pages/StudentDashboard/StudentProfile.js";
import OnBoardingForm from "../pages/ScholarshipForm/OnBoarding.jsx";
import OrphanStatusModal from "../components/OrphanStatusModal";

const adminRoutesData = [
  { path: "", element: <Dashboard />, text: "Dashboard" },
  { path: "application", element: <Applications />, text: "My Applications" },
  { path: "my-documents", element: <MyDocuments />, text: "My Documents" },
  { path: "my-profile", element: <StudentProfile />, text: "My Profile" },
];

const StudentRoutes = () => {
  const userdetail = useSelector((state) => state.mainSlice.userdetail);

  if (userdetail?.isBulk == "true") {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="on-boarding" replace />} />
        <Route path="on-boarding" element={<OnBoardingForm />} />
      </Routes>
    );
  }

  return (
    <>
      <OrphanStatusModal />
      <Routes>
        <Route path="/" element={<Layout navItems={adminRoutesData} />}>
          {adminRoutesData.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route path="apply-scholarship/:token" element={<ApplyForScholarship />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>
      </Routes>
    </>
  );
};

export default StudentRoutes;